module.exports = __webpack_public_path__ + "img/report.ee7d7ca3.svg";